// ============================================================
// AYASA — the shop page (sections/ayasa-shop.liquid)
// Ported from the approved mockup V10 (Roy, 28-09).
//
// Loaded from layout/theme.liquid on collection pages only, deferred and
// BEFORE the card player module: this script builds one .model-card per
// instrument, and ayasa-cards-3.js then mounts the site's own playable pan in
// each — the same order the homepage's cards rely on. Nothing here changes
// the model cards, the player or ayasa-data.js; it only reads MODELS.
//
// The site's own pieces do the rest: Watch is a .hear-btn[data-model] (the
// video lightbox in ayasa-core-6.js), the heart is a .shortlist-btn (the
// wishlist), and Add to cart is the product page's own case and t-shirt
// choices (snippets buy-case-option / buy-shirt-option, cloned from the
// section's <template>) driven by initPlayerPurchaseOptions.
//
// Phones: the version Studio names for a phone is the only one shown there,
// with no view switch, and every version gets the sticky filter bar and the
// site's page gutter (the .as-phone class). The line below is the marker the
// studio looks for before it lets a phone choice be saved.
// card-versions contract 1
// ============================================================
(() => {
  const root = document.getElementById("ayshop");
  const dataEl = document.getElementById("asProducts");
  if (!root || !dataEl) return;

  let PRODUCTS = [];
  try { PRODUCTS = JSON.parse(dataEl.textContent); } catch (e) { console.error("shop data:", e); return; }
  // the badge's words come translated and HTML-escaped (' as &#39;): plain words here
  const plainText = document.createElement("textarea");
  PRODUCTS.forEach(p => (p.conds || []).forEach(c => { if (c.badge) { plainText.innerHTML = c.badge; c.badge = plainText.value; } }));
  const ALL_MODELS = typeof MODELS !== "undefined" ? MODELS : [];
  const $ = id => document.getElementById(id);

  // ---- DRAFTS for Ralf to confirm (28-09): mood, the line under each name,
  // the "Good first handpan" picks and the scale name shown on each row.
  // Keyed by the model's name in Studio; a model without an entry simply
  // shows the first sentence of its card description and no mood.
  const DRAFTS = {
    "D Aegean 18": ["mysterious", AYASA_t("js.shop.feel_d_aegean_18")],
    "E Amara 20": ["calm", AYASA_t("js.shop.feel_e_amara_20"), true],
    "F# Low Pygmy 21": ["deep", AYASA_t("js.shop.feel_fis_low_pygmy_21")],
    "D Aegean 20": ["mysterious", AYASA_t("js.shop.feel_d_aegean_20")],
    "D Kurd 19": ["deep", AYASA_t("js.shop.feel_d_kurd_19"), true],
    "D Ashakiran 19": ["uplifting", AYASA_t("js.shop.feel_d_ashakiran_19"), true],
    "B2 Aavartan 17": ["deep", AYASA_t("js.shop.feel_b2_aavartan_17")],
    "F#2 Nordlys 16": ["mysterious", AYASA_t("js.shop.feel_fis2_nordlys_16")],
    "C Ashakiran 17": ["uplifting", AYASA_t("js.shop.feel_c_ashakiran_17"), true],
    "B3 Pygmy 20": ["calm", AYASA_t("js.shop.feel_b3_pygmy_20")],
    "Elements D Kurd 13": ["deep", AYASA_t("js.shop.feel_elements_d_kurd_13"), true],
    "Elements D Kurd 15": ["deep", AYASA_t("js.shop.feel_elements_d_kurd_15"), true],
    "Elements E Amara 15": ["calm", AYASA_t("js.shop.feel_elements_e_amara_15"), true],
  };
  const SCALE = {
    "D Aegean 18": "D Lydian (F# minor)", "D Aegean 20": "D Lydian (F# minor)", "E Amara 20": "E Celtic minor",
    "F# Low Pygmy 21": "F# Pygmy", "D Kurd 19": "D Kurd", "D Ashakiran 19": "D major", "B2 Aavartan 17": "B major",
    "F#2 Nordlys 16": "F# Lydian (F# minor)", "C Ashakiran 17": "C major", "B3 Pygmy 20": "B Pygmy",
    "Elements D Kurd 13": "D Kurd", "Elements D Kurd 15": "D Kurd", "Elements E Amara 15": "E Celtic minor",
  };
  // Top seller: the `top-seller` product tag. Until those tags are set in the
  // admin, the four Roy chose (28-09) carry it.
  const TOP_FALLBACK = new Set(["d-kurd-19-ember-steel", "e-amara-20-ember-steel", "fis-low-pygmy-21-ember-steel", "d-aegean-20-ember-steel"]);

  const MOODS = [{ key: "calm", label: AYASA_t("js.shop.mood_calm") }, { key: "uplifting", label: AYASA_t("js.shop.mood_uplifting") }, { key: "mysterious", label: AYASA_t("js.shop.mood_mysterious") }, { key: "deep", label: AYASA_t("js.shop.mood_deep") }];
  const KEYS = ["C", "D", "E", "F", "F#", "G", "A", "B"];
  const LINES = [{ key: "premium", label: "Ayasa Premium" }, { key: "elements", label: "Ayasa Elements" }];

  const money = c => ayasaMoney(c, false);
  const eur = c => ayasaMoney(c, true);
  const esc = s => String(s == null ? "" : s).replace(/[&<>"]/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
  const cleanTitle = t => String(t).replace(/\s*-?\s*440Hz/i, "").replace(/\s*-?\s*Ember Steel®?/i, "").trim();
  const now = Date.now();
  const future = d => !!d && new Date(d).getTime() > now;

  // ---- the rows: every instrument product, plus the Elements from Studio ----
  const byHandle = new Map();
  ALL_MODELS.forEach(m => { if (m.productHandle) byHandle.set(m.productHandle, m); });
  const baseOf = h => h.replace(/-(scratched|spotted)$/, "");
  const modelFor = p => byHandle.get(p.handle) || p.conds.map(c => byHandle.get(c.handle)).find(Boolean) || byHandle.get(baseOf(p.handle)) || null;
  // "11 Nov 2026"; in another language the way it writes dates ("11. Nov. 2026")
  const shortDate = iso => {
    const dt = new Date(iso);
    if (AYASA_LOCALE === "en") return `${dt.getUTCDate()} ${dt.toLocaleDateString("en-GB", { month: "long", timeZone: "UTC" }).slice(0, 3)} ${dt.getUTCFullYear()}`;
    return dt.toLocaleDateString(AYASA_LOCALE, { day: "numeric", month: "short", year: "numeric", timeZone: "UTC" });
  };
  const shortAvail = c => {
    if (!c) return "";
    if (c.stock) return AYASA_t("js.shop.in_stock_ships_soon");
    // from the ships: date, not from the badge's words, which are the page's language
    if (c.ship && future(c.ship)) return AYASA_t("js.shop.made_for_you_ships", { date: shortDate(c.ship) });
    if (c.production) return AYASA_t("js.shop.made_for_you_in_production");
    return c.badge || "";
  };
  // a condition's name as shown; "Standard", "Scratched", "Spotted" stay the
  // English values the code matches on (snippets/shop-cond-json.liquid)
  const KIND = { Standard: "js.shop.kind_standard", Scratched: "js.shop.kind_scratched", Spotted: "js.shop.kind_spotted" };
  const kindName = k => KIND[k] ? AYASA_t(KIND[k]) : k;
  const fromTitle = title => {
    const t = cleanTitle(title);
    const key = (/^([A-G](#|b)?)/.exec(t) || [])[1] || "";
    const n = +((/(\d+)\s*$/.exec(t) || [])[1] || 0);
    return { key, n, tone: /kurd|pygmy|amara|minor/i.test(t) ? "minor" : "major", scale: t.replace(/\s*\d+\s*$/, "") };
  };

  const ITEMS = [];
  for (const p of PRODUCTS) {
    const m = modelFor(p);
    const conds = p.conds || [];
    const buyable = conds.filter(c => c.available);
    const primary = buyable[0] || conds[0];
    if (!primary) continue;
    const others = buyable.filter(c => c !== primary);
    const guess = fromTitle(p.title);
    const name = m ? m.name : cleanTitle(p.title);
    const d = DRAFTS[name] || [];
    const dm = primary.ship && future(primary.ship) ? new Date(primary.ship).getTime() : null;
    ITEMS.push({
      name, handle: primary.handle, url: primary.url, model: m, modelIdx: m ? ALL_MODELS.indexOf(m) : -1,
      line: m && m.range === "elements" ? "elements" : "premium",
      cardPhoto: m ? m.cardPhoto || null : null, image: p.image,
      price: primary.price, compareAt: primary.compare || null, primary, seconds: others, buyable,
      cond: primary.kind !== "Standard" ? primary.kind : null,
      shipsNow: !!primary.stock, shipRank: primary.stock ? 0 : dm || 9e15, availShort: shortAvail(primary),
      key: m ? String(m.ding || "").replace(/\d/g, "") : guess.key,
      tone: m ? (/-major$/.test(m.family || "") ? "major" : "minor") : guess.tone,
      scaleName: SCALE[name] || (m ? String(m.scale || "").split("·")[0].trim() : guess.scale),
      ding: m ? m.ding : "", top: m ? m.top || [] : [], bottom: m ? m.bottom || [] : [],
      notesN: m ? 1 + (m.top || []).length + (m.bottom || []).length : guess.n,
      mood: d[0] || null, moodLine: d[1] || (m && m.desc ? m.desc.split(/(?<=\.)\s/)[0] : ""), first: !!d[2],
      // card-versions top-seller 1
      topSeller: m && typeof m.topSeller === "boolean" ? m.topSeller
        : (p.tags || []).includes("top-seller") || TOP_FALLBACK.has(p.handle) || conds.some(c => TOP_FALLBACK.has(c.handle)),
      artists: m ? [...new Set((m.videos || []).map(v => v.artist).filter(Boolean))] : [],
      videoCount: m ? (m.videos || []).length : 0,
    });
  }
  // the Elements line: cards in Studio, no shop product (and so no price) yet
  const listed = new Set(ITEMS.map(it => it.model).filter(Boolean));
  for (const m of ALL_MODELS) {
    if (m.range !== "elements" || !m.pan || m.productHandle || listed.has(m)) continue;
    const d = DRAFTS[m.name] || [];
    const dm = /Ships (\d{1,2}) (\w+) (\d{4})/.exec(m.availability || "");
    ITEMS.push({
      name: m.name, handle: null, url: null, model: m, modelIdx: ALL_MODELS.indexOf(m), line: "elements",
      cardPhoto: m.cardPhoto || null, image: null, price: null, compareAt: null, primary: null, seconds: [], buyable: [], cond: null,
      shipsNow: !!m.inStock, shipRank: m.inStock ? 0 : dm ? new Date(`${dm[2]} ${dm[1]}, ${dm[3]}`).getTime() : 9e15,
      availShort: m.inStock ? AYASA_t("js.shop.in_stock_ships_soon") : dm ? AYASA_t("js.shop.made_for_you_ships", { date: `${dm[1]} ${dm[2].slice(0, 3)} ${dm[3]}` }) : AYASA_t("js.shop.made_for_you"),
      key: String(m.ding || "").replace(/\d/g, ""), tone: /-major$/.test(m.family || "") ? "major" : "minor",
      scaleName: SCALE[m.name] || String(m.scale || "").split("·")[0].trim(),
      ding: m.ding, top: m.top || [], bottom: m.bottom || [], notesN: 1 + (m.top || []).length + (m.bottom || []).length,
      mood: d[0] || null, moodLine: d[1] || (m.desc ? m.desc.split(/(?<=\.)\s/)[0] : ""), first: !!d[2], topSeller: m.topSeller === true,
      artists: [...new Set((m.videos || []).map(v => v.artist).filter(Boolean))], videoCount: (m.videos || []).length,
    });
  }
  if (!ITEMS.length) return;

  const liveSeconds = it => it.seconds;
  const low = (it, withSeconds) => it.price == null ? null : Math.min(it.price, ...(withSeconds ? it.seconds.map(s => s.price) : []));
  const PRICED = ITEMS.filter(it => it.price != null);
  const PMIN = PRICED.length ? Math.floor(Math.min(...PRICED.map(it => low(it, true))) / 50000) * 50000 : 0;
  const PMAX = PRICED.length ? Math.ceil(Math.max(...PRICED.map(it => it.price)) / 50000) * 50000 : 0;
  const NOTES = ITEMS.map(it => it.notesN).filter(n => n > 0);
  const NMIN = NOTES.length ? Math.min(...NOTES) : 0, NMAX = NOTES.length ? Math.max(...NOTES) : 0;
  // "Case from €…": the cheapest case the product page's own case list offers
  const tpl = $("asBuy");
  const casePrices = tpl ? [...tpl.content.querySelectorAll("#caseSelect option[data-price]:not([disabled])")].map(o => +o.dataset.price).filter(Boolean) : [];
  const caseFrom = casePrices.length ? Math.min(...casePrices) : null;

  // the render and its stored turn, the same numbers the player uses
  const thumb = (it, cls = "thumb") => {
    const r = it.model && it.model.pan && it.model.pan.render;
    const src = (r && r.src) || it.image || "";
    return `<img class="${cls}" src="${esc(src)}" alt="" style="transform: rotate(${Number(r && r.spin) || 0}deg)">`;
  };

  // ---- which version of the page (Roy + Ralf, 29-09) ----
  // A version chooser, not an editor: every version below is built in, and
  // Studio → Settings → model cards names the one customers see, on a phone and
  // on a computer (AYASA_CFG.shopLayout, written by the studio; the names are
  // the contract in the website repo's studio/card-versions.mjs). To look at
  // another version without changing it for anyone, ?phone=…&desktop=… works
  // on the preview (behind its login) and a local dev theme, never the live shop.
  // "merge": the merged card; with the switch on, its rows are the same cards
  // laid out wide (.v-mrows). The line below is the studio's marker for them.
  // card-versions merge-rows 2
  const LAYOUTS = ["cards", "classic-a", "classic-b", "classic-c", "list", "grid", "merge"];
  const CFG_SHOP = (typeof AYASA_CFG !== "undefined" && AYASA_CFG && AYASA_CFG.shopLayout) || {};
  const WANT = { phone: CFG_SHOP.phone, desktop: CFG_SHOP.desktop, toggle: CFG_SHOP.toggle !== false, opens: CFG_SHOP.opens, rows: CFG_SHOP.rows };
  if (/^(preview\.ayasa-studio\.com|127\.0\.0\.1|localhost)$/.test(location.hostname)) {
    const qs = new URLSearchParams(location.search);
    for (const k of ["phone", "desktop"]) if (qs.has(k)) WANT[k] = qs.get(k);
    if (qs.has("toggle")) WANT.toggle = qs.get("toggle") !== "0";
  }
  // decided once at load: the players mount once, so a later resize keeps what was built
  const IS_PHONE = matchMedia("(max-width: 900px)").matches;
  // the phone's sticky bar and gutter (the CSS) belong to the phone, whichever version it shows
  root.classList.toggle("as-phone", IS_PHONE);
  let LAYOUT = IS_PHONE ? WANT.phone : WANT.desktop;
  // The merged card on the grid with the old row for rows (Studio: shopLayout.rows
  // "list", Ralf 30-09). They are two different cards, and the player mounts every
  // card once, so the switch reloads into the other layout; the pick is kept.
  const MIXROWS = !IS_PHONE && WANT.desktop === "merge" && WANT.rows === "list" && WANT.toggle;
  if (MIXROWS) {
    let v = "";
    try { v = String(localStorage.getItem("ayasaShopView") || "").split("@mix")[0]; } catch (e) {}
    if (v === "list" || (!v && WANT.opens === "list")) LAYOUT = "list";
  }
  if (!LAYOUTS.includes(LAYOUT)) LAYOUT = IS_PHONE ? "cards" : "list";       // today's shop
  if (LAYOUT !== "list" && LAYOUT !== "grid" && typeof modelCard !== "function") LAYOUT = "list";
  const CARDS = LAYOUT !== "list" && LAYOUT !== "grid";
  const CARD_STYLE = LAYOUT === "cards" ? "big" : LAYOUT === "merge" ? "merge" : "classic";
  // classic cards: the order of the price, the cart and the wishlist heart in the top corner
  const CORNER = { "classic-a": ["price", "cart", "heart"], "classic-b": ["cart", "price", "heart"], "classic-c": ["heart", "cart", "price"] }[LAYOUT] || null;
  // list or grid: the version chosen, and the visitor's own switch when it is on
  const TOGGLE = WANT.toggle && !IS_PHONE;     // a phone shows the one version Studio names, with no switch
  // A visitor's own press of the switch is remembered, but only under the
  // version it was made against ("grid@list"): a new choice in Studio reaches
  // returning visitors too instead of being hidden behind an old press.
  // the merged card switches between its grid and its rows in place (no rebuild,
  // so the pans stay mounted); it opens on what Studio says (WANT.opens)
  const MROWS = LAYOUT === "merge" && TOGGLE && !MIXROWS;
  let prefView = LAYOUT === "grid" || (LAYOUT === "merge" && !(MROWS && WANT.opens === "list")) ? "grid" : "list";
  const VIEW_KEY = "ayasaShopView";
  if (TOGGLE) try {
    const [v, made] = String(localStorage.getItem(VIEW_KEY) || "").split("@");
    if ((v === "list" || v === "grid") && made === LAYOUT) prefView = v;
  } catch (e) {}
  const S = { lines: new Set(LINES.map(l => l.key)), now: false, tone: "all", keys: new Set(), moods: new Set(), first: false, seconds: true,
    pmin: PMIN, pmax: PMAX, nmin: NMIN, nmax: NMAX, sort: "featured", view: prefView === "grid" ? "grid" : "list", compare: [] };

  const HEART = `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.3C7.2 16.6 3.5 13.5 3.5 9.9 3.5 7.2 5.6 5 8.2 5c1.5 0 3 .7 3.8 1.9C12.8 5.7 14.3 5 15.8 5c2.6 0 4.7 2.2 4.7 4.9 0 3.6-3.7 6.7-8.5 10.4z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>`;
  const CMP = `<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><rect x="2.5" y="4" width="6" height="12" rx="1.2"/><rect x="11.5" y="4" width="6" height="12" rx="1.2"/></svg>`;
  const CART = `<svg class="cart" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1.8 2.5h2.4l2 10.2h9.6l1.9-7.2H5.1"/><circle cx="7.6" cy="16.4" r="1.2"/><circle cx="14.4" cy="16.4" r="1.2"/></svg>`;
  // the house round-close cross (DEMO_ICON_CLOSE in ayasa-core-6.js)
  const CLOSE = `<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>`;

  const keyFact = it => esc(it.scaleName);
  const notesFact = it => it.notesN ? `${AYASA_t("js.shop.notes_count", { n: it.notesN })}${it.bottom.length ? ` · ${AYASA_t("js.shop.on_the_bottom", { n: it.bottom.length })}` : ""}` : "";
  const playedBy = it => { if (!it.artists.length) return ""; const f = it.artists.includes("Malte Marten") ? "Malte Marten" : it.artists[0]; return `Played by ${f}${it.artists.length > 1 ? ` + ${it.artists.length - 1} more` : ""}`; };
  // at most two labels; a sale shows in the crossed-out price, a condition in the spec line
  // the labels' words as Studio names them (AYASA_CFG.cardLabels, Ralf 30-09), else today's
  // card-versions labels 1
  const LABEL = Object.assign({ now: AYASA_t("js.shop.ships_now"), top: AYASA_t("js.shop.top_seller"), made: AYASA_t("js.shop.made_to_order") },
    (typeof AYASA_CFG !== "undefined" && AYASA_CFG && AYASA_CFG.cardLabels) || {});
  const labels = it => [it.shipsNow ? `<span class="label now">${esc(LABEL.now)}</span>` : "", it.topSeller ? `<span class="label top">${esc(LABEL.top)}</span>` : ""].join("");
  const specLine = it => [`<b>${esc(it.scaleName)}</b>`, esc(notesFact(it)), it.cond ? esc(AYASA_t("js.shop.cosmetic_marks", { cond: kindName(it.cond) })) : ""].filter(Boolean).join(" · ");
  // the struck-through old price sits before the live one, as on the product page
  const priceHTML = it => it.price == null ? esc(AYASA_t("js.shop.price_to_follow")) : `${it.compareAt && it.compareAt > it.price ? `<s>${money(it.compareAt)}</s>` : ""}${money(it.price)}`;
  const secondText = it => S.seconds && it.seconds.length ? AYASA_t("js.shop.also_as", { list: it.seconds.map(s => AYASA_t("js.shop.kind_from", { kind: kindName(s.kind), price: money(s.price) })).join(", ") }) : "";
  const avail = it => it.availShort;
  const availHTML = it => `<p class="avail${it.shipsNow ? "" : " order"}"><i aria-hidden="true"></i>${esc(avail(it))}</p>`;
  const addBtn = i => {
    const it = ITEMS[i];
    if (it.price == null) return `<button type="button" class="btn btn-ghost soon" disabled>${esc(AYASA_t("js.shop.coming_soon"))}</button>`;
    if (!it.buyable.length) return `<button type="button" class="btn btn-ghost soon" disabled>${esc(AYASA_t("js.shop.sold_out"))}</button>`;
    return `<button type="button" class="btn btn-primary add" data-i="${i}">${CART}${esc(AYASA_t("js.shop.add_to_cart"))}</button>`;
  };
  const watchBtn = it => it.videoCount && it.modelIdx >= 0
    ? `<button type="button" class="hear-btn watch-btn" data-model="${it.modelIdx}" aria-haspopup="dialog" aria-label="${esc(AYASA_t("js.shop.watch_being_played", { name: it.name }))}"><span class="hear-play" aria-hidden="true">▶</span>${esc(AYASA_t("js.shop.watch"))}</button>` : "";

  // one element per instrument, built ONCE: the player mounted in it keeps its
  // state, so filtering and sorting only hide and reorder, never rebuild
  function itemHTML(it, i) {
    const bg = it.cardPhoto ? `<div class="item-bg" style="background-image: url('${esc(it.cardPhoto)}')" aria-hidden="true"></div><div class="item-bg2" style="background-image: url('${esc(it.cardPhoto)}')" aria-hidden="true"></div>` : "";
    // the player finds its model by the (hidden) name heading in the card
    const player = it.model && it.model.pan
      ? `<div class="player model-card">
          <h3 hidden>${esc(it.model.name)}</h3>
          <div class="notemap"><div class="loading-pan" aria-hidden="true"></div></div>
          <p class="notemap-bottom" hidden></p>
          <div class="model-actions"><button type="button" class="hear-btn play-btn" data-i="${i}" aria-label="${esc(AYASA_t("js.shop.play_name", { name: it.name }))}"><span class="hear-play" aria-hidden="true">♪</span>${esc(AYASA_t("js.shop.play"))}</button>${watchBtn(it)}</div>
        </div>`
      : `<div class="player nomodel">${it.image ? `<a href="${esc(it.url)}" tabindex="-1" aria-hidden="true"><img src="${esc(it.image)}" alt="" loading="lazy"></a>` : ""}</div>`;
    const heart = it.url ? `<button type="button" class="iconbtn heart shortlist-btn" data-handle="${esc(it.handle)}" data-name="${esc(it.name)}" aria-pressed="false" aria-label="${esc(AYASA_t("js.shop.add_name_to_wishlist", { name: it.name }))}" title="${esc(AYASA_t("js.shop.add_to_wishlist"))}">${HEART}</button>` : "";
    return `<article class="item" data-i="${i}">${bg}
      ${player}
      <div class="body">
        <div class="namerow">${labels(it) ? `<div class="labels">${labels(it)}</div>` : ""}<h3>${it.url ? `<a href="${esc(it.url)}">${esc(it.name)}</a>` : esc(it.name)}</h3></div>
        ${it.moodLine ? `<p class="feel">${esc(it.moodLine)}</p>` : ""}
        <p class="spec">${specLine(it)}</p>
        ${availHTML(it)}
      </div>
      <div class="side">
        <span class="price${it.price == null ? " tbc" : ""}">${priceHTML(it)}</span>
        <span class="price price-cards"></span>
        <p class="second"></p>
        ${it.price != null && caseFrom ? `<p class="extras">${esc(AYASA_t("js.shop.case_from_free_tshirt", { price: money(caseFrom) }))}</p>` : ""}
        <div class="actions">${it.url ? `<a class="details" href="${esc(it.url)}">${esc(AYASA_t("js.shop.details"))} <span class="arrow" aria-hidden="true">→</span></a>` : `<span class="details"></span>`}${heart}<button type="button" class="iconbtn cmp" data-i="${i}" aria-pressed="false" aria-label="${esc(AYASA_t("js.shop.compare_name", { name: it.name }))}" title="${esc(AYASA_t("js.shop.compare"))}">${CMP}</button>${addBtn(i)}</div>
      </div></article>`;
  }
  // ---- the card versions (Roy, 29-09): the instruments page's own model cards ----
  // Each instrument is the SAME card the instruments section draws (modelCard
  // in ayasa-core, so the two can never drift apart: a new model, photo or text
  // in Studio shows here by itself). Both styles count the notes in blue and
  // buy through the same case and t-shirt panel as the rows. No compare there.
  //   big (version "cards"): the pan bigger with its runs under it, "Details →"
  //     next to Full Player, and the ship date, price and a round cart below.
  //   classic (versions "classic-a/b/c"): the card exactly as on the
  //     instruments section, a cart by the wishlist heart in the same round
  //     style with the price beside them, and "View details →".
  function cardHTML(it, i) {
    const html = it.model
      ? modelCard(it.model)
      // an instrument with no card in Studio: the same card, its product
      // photo where the playable pan would be
      : `<article class="model-card as-card-photo">
          ${it.handle ? `<button type="button" class="shortlist-heart" data-handle="${esc(it.handle)}" data-name="${esc(it.name)}" aria-label="${esc(AYASA_t("js.shop.add_name_to_wishlist", { name: it.name }))}" aria-pressed="false">${HEART}</button>` : ""}
          <div class="model-head"><h3>${esc(it.name)}</h3></div>
          <p class="model-scale">${esc(it.scaleName)}</p>
          ${it.image ? `<div class="as-card-img"><img src="${esc(it.image)}" alt="${esc(it.name)}" loading="lazy"></div>` : ""}
          ${it.moodLine ? `<p class="model-desc">${esc(it.moodLine)}</p>` : ""}
          <div class="model-actions"></div>
          <div class="model-foot"><span class="badge"></span></div>
        </article>`;
    const t = document.createElement("template");
    t.innerHTML = html.trim();
    const card = t.content.firstElementChild;
    // built after the page's reveal pass, so no fade-in class
    card.classList.remove("reveal");
    card.classList.add("as-card", `as-${CARD_STYLE}`);
    card.dataset.i = i;
    const nameH = card.querySelector(".model-head h3");
    if (nameH && it.url && !nameH.querySelector("a")) nameH.innerHTML = `<a class="as-name" href="${esc(it.url)}">${esc(nameH.textContent.trim())}</a>`;
    // the notes line counts instead of listing (Roy, 29-09): "13 top notes and
    // 7 bottom notes". The top counts the ding, as the pan's name does (E Amara
    // 20 = 13 + 7). Counted from the model, so a changed layout in Studio follows.
    // The player owns .notemap-bottom (it rewrites it on mount and on every turn),
    // so that one is hidden here and this line sits after it
    const nb = card.querySelector(".notemap-bottom");
    if (nb && it.model) {
      const top = 1 + (it.model.top || []).length, bot = (it.model.bottom || []).length;
      const n = (k, one, other) => esc(AYASA_t(k === 1 ? one : other)).replace("{n}", () => `<b>${k}</b>`);
      const nTop = n(top, "js.shop.top_notes_one", "js.shop.top_notes_other");
      nb.insertAdjacentHTML("afterend", `<p class="as-notecount">${bot ? esc(AYASA_t("js.shop.top_and_bottom")).replace("{top}", () => nTop).replace("{bottom}", () => n(bot, "js.shop.bottom_notes_one", "js.shop.bottom_notes_other")) : nTop}</p>`);
    }
    // the product's own availability words, as its product page shows them
    const badge = card.querySelector(".model-foot .badge");
    if (badge && it.primary) {
      badge.className = `badge ${it.shipsNow ? "badge-stock" : "badge-order"}`;
      // big: on two lines beside the price, "Made for you." / "Ships 11 November 2026"
      const words = String(it.primary.badge || it.availShort).split(/(?<=\.)\s+/);
      badge.innerHTML = CARD_STYLE === "big" ? words.map(w => `<span class="l">${esc(w)}</span>`).join("") : esc(words.join(" "));
      badge.removeAttribute("data-handle");
    }
    if (CARD_STYLE === "classic") return classicCard(card, it, i);
    if (CARD_STYLE === "merge") return mergeCard(card, it, i);
    // big: the card is no longer one big link, Details is
    card.classList.remove("model-card-linked");
    // Roy, 29-09 (mockup option A): "View in shop →" gives way to a round cart
    // button in the house gradient. Ralf, 30-09: "Details →" sits in the bottom
    // row, above the price and the cart, no longer beside Full Player.
    // Built to survive a change to the house card: a missing actions row or
    // foot is added, and whatever link or price line the foot carries is swapped
    let actions = card.querySelector(".model-actions");
    let foot = card.querySelector(".model-foot");
    if (!foot) { foot = document.createElement("div"); foot.className = "model-foot"; card.appendChild(foot); }
    if (!actions) { actions = document.createElement("div"); actions.className = "model-actions"; foot.before(actions); }
    foot.querySelectorAll(".model-link, .model-price").forEach(el => el.remove());
    // the price beside the ship date (Roy, 29-09), in the house card price look,
    // with the cart after it and Details above the two (.as-buy)
    const buyRow = (it.price != null ? `<span class="model-price as-price">${priceHTML(it)}</span>` : "") + (it.price == null
      ? `<span class="model-price">${esc(AYASA_t("js.shop.coming_soon"))}</span>`
      : !it.buyable.length
        ? `<button type="button" class="as-cart" disabled aria-label="${esc(AYASA_t("js.shop.name_sold_out", { name: it.name }))}" title="${esc(AYASA_t("js.shop.sold_out"))}">${CART}</button>`
        : `<button type="button" class="as-cart add" data-i="${i}" aria-label="${esc(AYASA_t("js.shop.add_name_to_cart", { name: it.name }))}" title="${esc(AYASA_t("js.shop.add_to_cart"))}">${CART}</button>`);
    foot.insertAdjacentHTML("beforeend", `<div class="as-buy">${it.url
      ? `<a class="model-link as-details" href="${esc(it.url)}" aria-label="${esc(AYASA_t("js.shop.details_of", { name: it.name }))}">${esc(AYASA_t("js.shop.details"))} <span class="arrow" aria-hidden="true">→</span></a>`
      : ""}<div class="as-buy-row">${buyRow}</div></div>`);
    return card.outerHTML;
  }
  // merge (Ralf, 30-09): the big card made small for the grid. From the big
  // card: the pan bigger with its runs under it (.as-big), the scale, Watch and
  // Full Player. From the grid tile: Ships now and Top seller above the name,
  // the notes line and the availability line, and the bottom row with the
  // price, Details, the heart and Add to cart, without compare. No description.
  // The notes line (Ralf, 30-09): the tonality as Studio saves it (the
  // family), with its relative, and the notes in all, no bottom count:
  // "F# Minor / A Major · 20 notes". A cosmetic second still says so.
  const MERGE_KEYS = { major: ["C", "Db", "D", "Eb", "E", "F", "F#", "G", "Ab", "A", "Bb", "B"], minor: ["C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "Bb", "B"] };
  const mergeTone = it => {
    // the family Studio saves, or for a pan with no card the shop key and tone
    const fam = (it.model && it.model.family) || (it.key ? `${it.key}-${it.tone || "minor"}` : "");
    const f = /^([a-g])(#|b)?-(major|minor)$/i.exec(fam);
    const Word = t => AYASA_t(t === "major" ? "js.shop.major" : "js.shop.minor");
    if (!f) return "";
    const tone = f[3].toLowerCase(), other = tone === "minor" ? "major" : "minor";
    const pc = ({ c: 0, d: 2, e: 4, f: 5, g: 7, a: 9, b: 11 }[f[1].toLowerCase()] + (f[2] === "#" ? 1 : f[2] === "b" ? -1 : 0) + 12) % 12;
    const rel = (pc + (tone === "minor" ? 3 : 9)) % 12;
    return `${MERGE_KEYS[tone][pc]} ${Word(tone)} / ${MERGE_KEYS[other][rel]} ${Word(other)}`;
  };
  const mergeSpec = it => {
    const tone = mergeTone(it);
    return [tone ? `<b>${esc(tone)}</b>` : "", it.notesN ? `<span class="as-mnotes">${esc(AYASA_t("js.shop.notes_count", { n: it.notesN }))}</span>` : "", it.cond ? esc(AYASA_t("js.shop.cosmetic_marks", { cond: kindName(it.cond) })) : ""].filter(Boolean).join(" · ");
  };
  function mergeCard(card, it, i) {
    card.classList.add("as-big");
    card.classList.remove("model-card-linked");
    card.querySelectorAll(".model-desc, .as-notecount, .shortlist-heart").forEach(el => el.remove());
    // the old row background has a second, faint copy of the photo at the right (rows only)
    const bg = card.querySelector(".model-card-bg");
    if (bg) bg.insertAdjacentHTML("afterend", `<div class="as-mbg2" style="${esc(bg.getAttribute("style") || "")}" aria-hidden="true"></div>`);
    const head = card.querySelector(".model-head");
    // Made to order (Ralf, 30-09): one that does not ship now but can be ordered
    const made = !it.shipsNow && it.price != null && it.buyable.length ? `<span class="label made">${esc(LABEL.made)}</span>` : "";
    if (head && (labels(it) || made)) head.insertAdjacentHTML("beforebegin", `<div class="labels as-mlabels">${made}${labels(it)}</div>`);
    let actions = card.querySelector(".model-actions");
    let foot = card.querySelector(".model-foot");
    if (!foot) { foot = document.createElement("div"); card.appendChild(foot); }
    if (!actions) { actions = document.createElement("div"); actions.className = "model-actions"; foot.before(actions); }
    // the old row's description (its mood line), shown in the rows view only
    if (it.moodLine) actions.insertAdjacentHTML("beforebegin", `<p class="feel as-mfeel">${esc(it.moodLine)}</p>`);
    actions.insertAdjacentHTML("beforebegin", `<div class="as-mfacts"><p class="spec">${mergeSpec(it)}</p></div>`);
    // the grid tile's price: "From" when a cosmetic second costs less
    const lo = low(it, S.seconds);
    const price = it.price != null && lo < it.price ? `<small class="price-from">${esc(AYASA_t("js.shop.from"))}</small>${money(lo)}` : priceHTML(it);
    const heart = it.url ? `<button type="button" class="iconbtn heart shortlist-btn" data-handle="${esc(it.handle)}" data-name="${esc(it.name)}" aria-pressed="false" aria-label="${esc(AYASA_t("js.shop.add_name_to_wishlist", { name: it.name }))}" title="${esc(AYASA_t("js.shop.add_to_wishlist"))}">${HEART}</button>` : "";
    foot.className = "model-foot as-mfoot";
    foot.innerHTML = `<div class="as-mbuy">${availHTML(it)}<span class="price${it.price == null ? " tbc" : ""}">${price}</span></div>` +
      `<div class="actions">${it.url ? `<a class="details" href="${esc(it.url)}">${esc(AYASA_t("js.shop.details"))} <span class="arrow" aria-hidden="true">→</span></a>` : `<span class="details"></span>`}${heart}${addBtn(i)}</div>`;
    return card.outerHTML;
  }
  // classic: the instruments card as it is, the whole card still opening the
  // instrument's page ("View details →" carries the link), and in the top
  // corner the price, a cart in the wishlist heart's round style, and the heart
  function classicCard(card, it, i) {
    let foot = card.querySelector(".model-foot");
    if (!foot) { foot = document.createElement("div"); foot.className = "model-foot"; card.appendChild(foot); }
    let link = foot.querySelector(".model-link");
    if (it.url) {
      if (!link) { foot.querySelectorAll(".model-price").forEach(el => el.remove()); foot.insertAdjacentHTML("beforeend", `<a class="model-link"></a>`); link = foot.querySelector(".model-link"); }
      link.href = it.url;
      link.setAttribute("aria-label", AYASA_t("js.shop.view_details_of", { name: it.name }));
      link.innerHTML = `${esc(AYASA_t("js.shop.view_details"))} <span class="arrow" aria-hidden="true">→</span>`;
      card.classList.add("model-card-linked");
    }
    if (it.price == null) return card.outerHTML;              // Elements: "Coming soon", no corner
    const heart = card.querySelector(".shortlist-heart");
    const part = {
      price: `<span class="as-cprice">${priceHTML(it)}</span>`,
      cart: !it.buyable.length
        ? `<button type="button" class="as-cart2" disabled aria-label="${esc(AYASA_t("js.shop.name_sold_out", { name: it.name }))}" title="${esc(AYASA_t("js.shop.sold_out"))}">${CART}</button>`
        : `<button type="button" class="as-cart2 add" data-i="${i}" aria-label="${esc(AYASA_t("js.shop.add_name_to_cart", { name: it.name }))}" title="${esc(AYASA_t("js.shop.add_to_cart"))}">${CART}</button>`,
      heart: heart ? heart.outerHTML : "",
    };
    heart?.remove();
    card.insertAdjacentHTML("afterbegin", `<div class="as-corner">${CORNER.map(k => part[k]).join("")}</div>`);
    card.classList.add("as-cornered");
    return card.outerHTML;
  }

  const EL = [];
  function buildItems() {
    const box = $("asItems");
    box.innerHTML = ITEMS.map(CARDS ? cardHTML : itemHTML).join("");
    box.querySelectorAll(":scope > [data-i]").forEach(el => { EL[+el.dataset.i] = el; });
    // list or grid without the visitor's switch: the chosen one only
    if (!CARDS && !TOGGLE) { const tog = root.querySelector(".as-viewtog"); if (tog) tog.style.display = "none"; }
    if (CARDS) {
      box.classList.add("range-grid");
      // the site syncs hearts and the phone scroll spotlight once, before
      // these cards existed: run both again now that they do
      try { if (typeof refreshShortlistUI === "function") refreshShortlistUI(); } catch (e) {}
      try { if (typeof initScrollSpotlight === "function") initScrollSpotlight(); } catch (e) {}
    }
    // the sticky bar (phones, every version) pins right under the header, which
    // shrinks once the page scrolls: follow its real height
    if (IS_PHONE) {
      const nav = document.getElementById("nav");
      if (nav && "ResizeObserver" in window) {
        const put = () => root.style.setProperty("--as-nav", `${Math.round(nav.getBoundingClientRect().height)}px`);
        put(); new ResizeObserver(put).observe(nav);
      }
    }
    // Play runs the top side through the player's own run button. Its own
    // listener stops the click here: the site opens its video lightbox for
    // any .hear-btn, and Play has no video to open.
    box.querySelectorAll(".play-btn").forEach(b => b.addEventListener("click", e => {
      e.preventDefault(); e.stopPropagation();
      // its own player, wherever it is (the compare dialog borrows it)
      b.closest(".player").querySelector(".pan-runs button:not(.notesbtn)")?.click();
    }));
  }

  // ---- filtering: each group's counts are worked out with the other groups applied ----
  function passes(it, skip) {
    return (skip === "line" || S.lines.has(it.line)) &&
      (skip === "now" || !S.now || it.shipsNow) &&
      (skip === "tone" || S.tone === "all" || it.tone === S.tone) &&
      (skip === "keys" || !S.keys.size || S.keys.has(it.key)) &&
      (skip === "moods" || !S.moods.size || S.moods.has(it.mood)) &&
      (skip === "notes" || !it.notesN || (it.notesN >= S.nmin && it.notesN <= S.nmax)) &&
      (skip === "first" || !S.first || it.first) &&
      (S.seconds || !it.cond) &&
      (skip === "price" || it.price == null || (low(it, S.seconds) >= S.pmin && low(it, S.seconds) <= S.pmax));
  }
  const n = (skip, test) => ITEMS.filter(it => passes(it, skip) && test(it)).length;
  const check = (id, label, count, on, extra = "") => `<label class="check${count === 0 && !on ? " off" : ""}"><input type="checkbox" id="${id}" ${on ? "checked" : ""} ${count === 0 && !on ? "disabled" : ""}>${esc(label)}${extra}<small>${count}</small></label>`;
  const dual = (key, label, unit, lo, hi, min, max, step) => `<div class="fgroup"><h2>${esc(label)}</h2>
      <div class="dual-in"><label>${esc(AYASA_t("js.shop.from"))}${unit}<input type="number" id="as${key}Min" min="${min}" max="${max}" step="${step}" value="${lo}"></label><span>–</span><label>${esc(AYASA_t("js.shop.to"))}${unit}<input type="number" id="as${key}Max" min="${min}" max="${max}" step="${step}" value="${hi}"></label></div>
      <div class="range"><div class="track"><div class="fill" id="as${key}Fill"></div></div>
        <input type="range" id="as${key}RMin" min="${min}" max="${max}" step="${step}" value="${lo}" aria-label="${esc(AYASA_t("js.shop.range_lowest", { label }))}">
        <input type="range" id="as${key}RMax" min="${min}" max="${max}" step="${step}" value="${hi}" aria-label="${esc(AYASA_t("js.shop.range_highest", { label }))}"></div></div>`;

  function renderFilters() {
    const f = $("asFilters");
    const tBtn = (k, l) => `<button type="button" data-tone="${k}" aria-pressed="${S.tone === k}">${esc(l)}${k === "all" ? "" : `<small>${n("tone", it => it.tone === k)}</small>`}</button>`;
    f.innerHTML = `
      <div class="f-head"><h2>${esc(AYASA_t("js.shop.filters"))}</h2><button type="button" class="close" data-close-f aria-label="${esc(AYASA_t("js.shop.close_filters"))}">${CLOSE}</button></div>
      <div class="fgroup"><h2>${esc(AYASA_t("js.shop.product_line"))}</h2>${LINES.map(l => check("as-l-" + l.key, l.label, n("line", it => it.line === l.key), S.lines.has(l.key))).join("")}</div>
      <div class="fgroup"><h2>${esc(AYASA_t("js.shop.availability"))}</h2>${check("as-now", AYASA_t("js.shop.ships_now"), n("now", it => it.shipsNow), S.now)}</div>
      <div class="fgroup"><h2>${esc(AYASA_t("js.shop.key"))}</h2>
        <div class="seg" role="group" aria-label="${esc(AYASA_t("js.shop.major_or_minor"))}">${tBtn("all", AYASA_t("js.shop.all"))}${tBtn("major", AYASA_t("js.shop.major"))}${tBtn("minor", AYASA_t("js.shop.minor"))}</div>
        <p class="fnote">${esc(AYASA_t("js.shop.key_note"))}</p>
        <div class="keys" role="group" aria-label="${esc(AYASA_t("js.shop.key"))}">${KEYS.map(k => { const c = n("keys", it => it.key === k); const on = S.keys.has(k); return `<button type="button" data-key="${k}" aria-pressed="${on}" ${c === 0 && !on ? "disabled" : ""}>${k}<small>${c}</small></button>`; }).join("")}</div>
      </div>
      ${PRICED.length ? dual("P", AYASA_t("js.shop.price"), ` (${ayasaCurrencySign()})`, S.pmin / 100, S.pmax / 100, PMIN / 100, PMAX / 100, 50) : ""}
      ${NOTES.length ? dual("N", AYASA_t("js.shop.number_of_notes"), "", S.nmin, S.nmax, NMIN, NMAX, 1) : ""}
      <div class="fgroup"><h2>${esc(AYASA_t("js.shop.sound"))}</h2>${MOODS.map(m => check("as-m-" + m.key, m.label, n("moods", it => it.mood === m.key), S.moods.has(m.key))).join("")}</div>
      <div class="fgroup"><h2>${esc(AYASA_t("js.shop.more"))}</h2>
        ${check("as-first", AYASA_t("js.shop.good_first_handpan"), n("first", it => it.first), S.first, `<span class="draft">${esc(AYASA_t("js.shop.draft"))}</span>`)}
        <label class="check"><input type="checkbox" id="as-sec" ${S.seconds ? "checked" : ""}>${esc(AYASA_t("js.shop.include_seconds"))}<small></small></label>
      </div>
      ${activeCount() ? `<button type="button" class="as-clear" id="asClearAll">${esc(AYASA_t("js.shop.clear_all_filters"))}</button>` : ""}
      <div class="f-foot"><button type="button" class="btn primary" data-close-f>${esc(AYASA_t("js.shop.show_handpans", { n: ITEMS.filter(it => passes(it)).length }))}</button></div>`;
    paintRanges();
  }
  function paintRanges() {
    const paint = (key, lo, hi, min, max) => { const f = $("as" + key + "Fill"); if (!f) return; const span = max - min || 1; f.style.left = ((lo - min) / span * 100) + "%"; f.style.width = ((hi - lo) / span * 100) + "%"; };
    paint("P", S.pmin, S.pmax, PMIN, PMAX); paint("N", S.nmin, S.nmax, NMIN, NMAX);
  }
  const priceActive = () => S.pmin !== PMIN || S.pmax !== PMAX;
  const notesActive = () => S.nmin !== NMIN || S.nmax !== NMAX;
  const activeCount = () => (S.lines.size < LINES.length ? 1 : 0) + (S.now ? 1 : 0) + (S.tone !== "all" ? 1 : 0) + S.keys.size + S.moods.size + (S.first ? 1 : 0) + (priceActive() ? 1 : 0) + (notesActive() ? 1 : 0);

  function renderPills() {
    const p = [];
    if (S.lines.size < LINES.length) p.push(["line", "", S.lines.size ? AYASA_t("js.shop.lines_only", { list: LINES.filter(l => S.lines.has(l.key)).map(l => l.label).join(", ") }) : AYASA_t("js.shop.no_product_line")]);
    if (S.now) p.push(["now", "", AYASA_t("js.shop.ships_now")]);
    if (S.tone !== "all") p.push(["tone", "", S.tone === "major" ? AYASA_t("js.shop.major") : AYASA_t("js.shop.minor")]);
    S.keys.forEach(k => p.push(["key", k, AYASA_t("js.shop.key_name", { key: k })]));
    S.moods.forEach(m => p.push(["mood", m, MOODS.find(x => x.key === m).label]));
    if (notesActive()) p.push(["notes", "", AYASA_t("js.shop.notes_range", { min: S.nmin, max: S.nmax })]);
    if (S.first) p.push(["first", "", AYASA_t("js.shop.good_first_handpan")]);
    if (priceActive()) p.push(["price", "", `${money(S.pmin)} – ${money(S.pmax)}`]);
    $("asPills").innerHTML = p.map(([t, v, l]) => `<button type="button" class="pill-x" data-pill="${t}" data-v="${esc(v)}" aria-label="${esc(AYASA_t("js.shop.remove_filter", { label: l }))}">${esc(l)}<span aria-hidden="true">×</span></button>`).join("");
    const fc = $("asFcount"); fc.hidden = !p.length; fc.textContent = p.length;
  }

  function renderItems() {
    const shown = ITEMS.map((it, i) => ({ it, i })).filter(x => passes(x.it));
    // card-versions shop-order 2
    const euros = x => x.it.price == null ? 999999 : low(x.it, S.seconds) / 100;
    const featured = x => (x.it.topSeller ? 0 : 2e10) + (x.it.shipsNow ? 0 : 1e10) + (x.it.modelIdx >= 0 ? x.it.modelIdx : 1000) * 1e6 + euros(x);
    const cmp = { featured: (a, b) => featured(a) - featured(b), ship: (a, b) => a.it.shipRank - b.it.shipRank || featured(a) - featured(b),
      asc: (a, b) => (low(a.it, S.seconds) ?? 1e12) - (low(b.it, S.seconds) ?? 1e12), desc: (a, b) => (low(b.it, S.seconds) ?? -1) - (low(a.it, S.seconds) ?? -1) }[S.sort];
    shown.sort(cmp);
    const box = $("asItems");
    const showSet = new Set(shown.map(x => x.i));
    EL.forEach((el, i) => { el.hidden = !showSet.has(i); });
    shown.forEach(x => box.appendChild(EL[x.i]));          // moving keeps each player alive
    if (!CARDS) EL.forEach((el, i) => {
      const s = el.querySelector(".second"), t = secondText(ITEMS[i]); s.textContent = t; s.hidden = !t;
      // the cards say "From" when a cosmetic second costs less, instead of a line about it
      const it = ITEMS[i], lo = low(it, S.seconds);
      el.querySelector(".price-cards").innerHTML = it.price != null && lo < it.price ? `<small class="price-from">${esc(AYASA_t("js.shop.from"))}</small>${money(lo)}` : priceHTML(it);
      el.querySelector(".cmp").setAttribute("aria-pressed", String(S.compare.includes(i)));
    });
    $("asResults").className = CARDS ? (MROWS ? `v-cards v-mtog${S.view === "list" ? " v-mrows" : ""}` : MIXROWS ? "v-cards v-mtog" : "v-cards") : S.view === "grid" ? "v-grid" : "v-list";
    $("asList").setAttribute("aria-pressed", String(S.view === "list"));
    $("asGrid").setAttribute("aria-pressed", String(S.view === "grid"));
    $("asCount").textContent = shown.length === ITEMS.length ? AYASA_t("js.shop.handpans_count", { n: ITEMS.length }) : AYASA_t("js.shop.handpans_shown", { n: shown.length, total: ITEMS.length });
    $("asTotal").textContent = ITEMS.length;
    $("asEmpty").hidden = shown.length > 0;
  }
  function renderAll() { renderFilters(); renderPills(); renderItems(); renderTray(); }

  // ---- compare ----
  // the site's one toast (the wishlist's shortlistToast): a .choice-popup that fades out
  function toast(msg) {
    document.querySelector(".as-toast")?.remove();
    const t = document.createElement("div");
    t.className = "choice-popup as-toast";
    t.setAttribute("role", "status");
    t.textContent = msg;
    document.body.appendChild(t);
    setTimeout(() => { t.classList.add("out"); setTimeout(() => t.remove(), 400); }, 2200);
  }
  function renderTray() {
    let tray = $("asTray");
    if (!S.compare.length) { if (tray) tray.remove(); return; }
    if (!tray) { tray = document.createElement("div"); tray.id = "asTray"; tray.className = "tray"; root.appendChild(tray); }
    tray.innerHTML = `<div class="thumbs">${S.compare.map(i => `<span class="tb">${thumb(ITEMS[i])}</span>`).join("")}</div>
      <p>${esc(AYASA_t("js.shop.compare_tray", { n: S.compare.length }))}</p><button type="button" class="x" id="asCmpClear">${esc(AYASA_t("js.shop.clear"))}</button>
      <button type="button" class="btn primary" id="asCmpOpen" ${S.compare.length < 2 ? "disabled" : ""}>${esc(AYASA_t("js.shop.compare"))}</button>`;
  }
  // ---- compare: the real, playable instruments side by side (Roy, 29-09) ----
  // The card player mounts once, at page load, on the rows' .model-card — so the
  // compare dialog BORROWS each row's own player (the DOM node, state and all)
  // and gives it back when the dialog closes. A placeholder keeps the row's size.
  let BORROWED = [];
  function returnPlayers() {
    BORROWED.forEach(({ p, ph }) => { ph.replaceWith(p); });
    BORROWED = [];
  }
  const NOTE_PC = { C: 0, D: 2, E: 4, F: 5, G: 7, A: 9, B: 11 };
  const midi = n => { const m = /^([A-G])(#|b)?(-?\d)$/.exec(String(n)); return m ? (+m[3] + 1) * 12 + NOTE_PC[m[1]] + (m[2] === "#" ? 1 : m[2] === "b" ? -1 : 0) : null; };
  const keyName = it => {
    const f = it.model && /^([a-g])(#|b)?-(major|minor)$/i.exec(it.model.family || "");
    const toneWord = t => AYASA_t(t.toLowerCase() === "major" ? "js.shop.major_lower" : "js.shop.minor_lower");
    return f ? `${f[1].toUpperCase()}${f[2] || ""} ${toneWord(f[3])}` : (it.key ? `${it.key} ${toneWord(it.tone)}` : "—");
  };
  const scaleDetail = it => it.model ? String(it.model.scale || "").split("·").slice(1).join("·").trim() : "";
  const chips = (notes, ding) => notes.length || ding
    ? `<div class="cnotes">${ding ? `<span class="n d" title="${esc(AYASA_t("js.shop.center_note"))}">${esc(ding)}</span>` : ""}${notes.map(x => `<span class="n">${esc(x)}</span>`).join("")}</div>` : "—";
  const range = it => {
    const all = [it.ding, ...it.top, ...it.bottom].filter(Boolean).map(n => ({ n, m: midi(n) })).filter(x => x.m != null).sort((a, b) => a.m - b.m);
    return all.length ? `${esc(all[0].n)} – ${esc(all[all.length - 1].n)}` : "—";
  };
  const videosCell = (it, k) => {
    const vids = it.model ? it.model.videos || [] : [];
    if (!vids.length) return `<span class="played">${esc(AYASA_t("js.shop.no_video_yet"))}</span>`;
    const who = it.artists.length ? esc(AYASA_t("js.shop.played_by", { names: it.artists.slice(0, 2).join(", ") })) + (it.artists.length > 2 ? ` + ${esc(AYASA_t("js.shop.n_more", { n: it.artists.length - 2 }))}` : "") : "";
    return `<p class="played">${esc(AYASA_t(vids.length === 1 ? "js.shop.videos_one" : "js.shop.videos_other", { n: vids.length }))}${who ? " · " + who : ""}</p>
      <button type="button" class="hear-btn cvid-toggle" data-k="${k}" aria-expanded="false"><span class="hear-play" aria-hidden="true">▶</span>${esc(AYASA_t("js.shop.watch"))}</button>
      <div class="cvid" id="asCvid${k}" hidden>
        <video playsinline controls preload="none"></video>
        <div class="cvid-artists">${vids.map((v, j) => `<button type="button" class="cvid-pick" data-k="${k}" data-j="${j}" aria-pressed="false">${esc(v.artist || AYASA_t("js.shop.video_n", { n: j + 1 }))}</button>`).join("")}</div>
      </div>`;
  };
  function openCompare() {
    const its = S.compare.map(i => ({ it: ITEMS[i], i }));
    const row = (label, f, cls = "") => `<tr${cls ? ` class="${cls}"` : ""}><th scope="row">${esc(label)}</th>${its.map((x, k) => `<td>${f(x.it, x.i, k)}</td>`).join("")}</tr>`;
    openLayer(`<div class="dialog cmpd" role="dialog" aria-modal="true" aria-labelledby="asCmpTitle">
      <div class="dhead"><h2 id="asCmpTitle">${esc(AYASA_t("js.shop.compare_handpans"))}</h2><button type="button" class="close" data-close aria-label="${esc(AYASA_t("js.shop.close"))}">${CLOSE}</button></div>
      <div class="ctable"><table>
        ${row("", it => `<div class="namerow">${labels(it) ? `<div class="labels">${labels(it)}</div>` : ""}<h3>${it.url ? `<a href="${esc(it.url)}">${esc(it.name)}</a>` : esc(it.name)}</h3></div>`, "c-name")}
        ${row("", (it, i, k) => `<div class="cplayer" data-k="${k}">${it.model && it.model.pan ? "" : `<div class="tbig">${thumb(it)}</div>`}</div>`, "c-player")}
        ${row(AYASA_t("js.shop.price"), it => `<span class="price">${priceHTML(it)}</span><p class="second">${esc(secondText(it))}</p>`)}
        ${row(AYASA_t("js.shop.availability"), it => availHTML(it))}
        ${row(AYASA_t("js.shop.key"), it => esc(keyName(it)))}
        ${row(AYASA_t("js.shop.scale"), it => `${esc(it.scaleName || "—")}${scaleDetail(it) ? `<p class="played">${esc(scaleDetail(it))}</p>` : ""}`)}
        ${row(AYASA_t("js.shop.notes"), it => it.notesN ? `${esc(AYASA_t("js.shop.notes_count", { n: it.notesN }))}${it.ding ? ` - ${esc(AYASA_t("js.shop.ding_center_note", { ding: it.ding }))}` : ""}${it.ding ? `<p class="played">${esc(AYASA_t("js.shop.on_top", { n: 1 + it.top.length }))}${it.bottom.length ? ` · ${esc(AYASA_t("js.shop.on_the_bottom", { n: it.bottom.length }))}` : ""}</p>` : ""}` : "—")}
        ${row(AYASA_t("js.shop.top_notes"), it => chips(it.top, it.ding))}
        ${row(AYASA_t("js.shop.bottom_notes"), it => it.bottom.length ? chips(it.bottom) : (it.model ? esc(AYASA_t("js.shop.none")) : "—"))}
        ${row(AYASA_t("js.shop.range"), it => range(it))}
        ${row(AYASA_t("js.shop.sound"), it => esc(it.moodLine || "—"))}
        ${row(AYASA_t("js.shop.about"), it => it.model && it.model.desc ? `<p class="cabout">${esc(it.model.desc)}</p>` : "—")}
        ${row(AYASA_t("js.shop.line"), it => it.line === "elements" ? "Ayasa Elements" : "Ayasa Premium")}
        ${row(AYASA_t("js.shop.videos"), (it, i, k) => videosCell(it, k))}
        ${row("", (it, i) => `<div class="cbuy">${it.url ? `<a class="details" href="${esc(it.url)}">${esc(AYASA_t("js.shop.details"))} <span class="arrow" aria-hidden="true">→</span></a>` : ""}${addBtn(i)}</div>`)}
      </table></div></div>`);
    // borrow the rows' own players into the "player" row
    its.forEach((x, k) => {
      const p = EL[x.i].querySelector(".player.model-card");
      const cell = $("asLayer").querySelector(`.cplayer[data-k="${k}"]`);
      if (!p || !cell) return;
      const r = p.getBoundingClientRect();
      const ph = document.createElement("div");
      ph.className = "player-ph"; ph.style.width = r.width + "px"; ph.style.height = r.height + "px";
      p.before(ph); cell.appendChild(p);
      BORROWED.push({ p, ph });
    });
  }
  // Watch inside compare opens the videos in the column itself, never the
  // lightbox on top of the comparison (Roy, 29-09)
  function compareVideo(k, j = 0) {
    const box = $("asCvid" + k); if (!box) return;
    const it = ITEMS[S.compare[k]], v = it.model.videos[j];
    document.querySelectorAll("#asLayer .cvid video").forEach(x => { if (x.closest(".cvid") !== box) x.pause(); });
    box.hidden = false;
    box.closest("td").querySelector(".cvid-toggle")?.setAttribute("aria-expanded", "true");
    const video = box.querySelector("video");
    if (typeof posterOf === "function") video.poster = posterOf(v.file);
    video.src = v.file;
    video.play().catch(() => {});
    if (typeof markWatched === "function") { try { markWatched(v.file); } catch (e) {} }
    box.querySelectorAll(".cvid-pick").forEach(b => b.setAttribute("aria-pressed", String(+b.dataset.j === j)));
    box.scrollIntoView({ block: "nearest", behavior: "smooth" });
  }
  // capture phase: the player's own Watch pill (a .hear-btn[data-model]) would
  // otherwise reach the site's lightbox handler on the document
  $("asLayer").addEventListener("click", e => {
    const t = e.target;
    const inCompare = t.closest(".cmpd");
    if (!inCompare) return;
    const pick = t.closest(".cvid-pick");
    if (pick) { e.preventDefault(); e.stopPropagation(); compareVideo(+pick.dataset.k, +pick.dataset.j); return; }
    const tog = t.closest(".cvid-toggle");
    if (tog) {
      e.preventDefault(); e.stopPropagation();
      const k = +tog.dataset.k, box = $("asCvid" + k);
      if (box && !box.hidden) { box.hidden = true; box.querySelector("video")?.pause(); tog.setAttribute("aria-expanded", "false"); }
      else compareVideo(k, 0);
      return;
    }
    const w = t.closest(".watch-btn");
    if (w) { e.preventDefault(); e.stopPropagation(); const k = +w.closest(".cplayer")?.dataset.k; if (!isNaN(k)) compareVideo(k, 0); }
  }, true);

  // ---- Add to cart: the product page's own case and t-shirt choices ----
  const shipLong = d => new Date(d).toLocaleDateString(AYASA_LOCALE === "en" ? "en-GB" : AYASA_LOCALE, { day: "numeric", month: "long", year: "numeric" });
  let QA = null;   // the open panel: item, its buyable conditions, the chosen one
  function openQuickAdd(i) {
    const it = ITEMS[i];
    if (!it.buyable.length || !tpl) return;
    QA = { i, conds: it.buyable, k: 0 };
    const condHTML = QA.conds.length > 1 ? `<span class="cond-wrap">
        <button type="button" class="cond-trigger" id="condTrigger" aria-expanded="false" aria-controls="condMenu">${esc(AYASA_t("js.shop.condition"))} <b id="condNow">${esc(kindName(QA.conds[0].kind))}</b> <span class="cond-chev" aria-hidden="true">▾</span></button>
        <span class="cond-menu" id="condMenu" hidden>
          ${QA.conds.map((c, k) => `<button type="button" class="cond-row${k === 0 ? " on" : ""}" data-k="${k}">${esc(kindName(c.kind))} <span>${money(c.price)}</span></button>`).join("")}
          <span class="cond-foot">${esc(AYASA_t("js.shop.condition_note"))}</span>
        </span>
      </span>` : "";
    openLayer(`<div class="dialog buy" role="dialog" aria-modal="true" aria-labelledby="asQaTitle">
      <div class="dhead"><h2 id="asQaTitle">${esc(AYASA_t("js.shop.add_to_cart"))}</h2><button type="button" class="close" data-close aria-label="${esc(AYASA_t("js.shop.close"))}">${CLOSE}</button></div>
      <form class="qa" id="asQaForm" data-i="${i}" novalidate>
        <div class="sum"><span class="tb">${thumb(it)}</span><div><h3 style="font-size:1.3rem">${esc(it.name)}</h3><p class="qa-price"><b id="qaPrice">${money(QA.conds[0].price)}</b>${condHTML}</p></div></div>
        <div class="buy-options" id="buyOptions"><div class="buy-options-inner" id="asQaOptions"></div></div>
        <p class="option-error" id="buyError" hidden></p>
        <p class="buy-total" id="buyTotal" hidden></p>
        <button type="submit" class="btn primary buy-go" id="buyGo"></button>
      </form></div>`);
    const opts = $("asQaOptions");
    opts.append(tpl.content.cloneNode(true));
    const shirtWrap = opts.querySelector("[data-shirt]");
    if (shirtWrap && !QA.conds[0].tshirt) shirtWrap.remove();
    if (typeof initPlayerPurchaseOptions === "function") initPlayerPurchaseOptions($("asLayer"), $("buyError"));
    $("caseSelect")?.addEventListener("change", qaTotal);
    qaTotal();
  }
  // the chosen condition's price, the total with the case, the button's words
  function qaTotal() {
    if (!QA || !$("asQaForm")) return;
    const c = QA.conds[QA.k], sel = $("caseSelect"), opt = sel && sel.selectedOptions[0];
    $("qaPrice").textContent = money(c.price);
    const total = $("buyTotal");
    total.textContent = opt && opt.value ? AYASA_t("js.shop.total", { price: eur(c.price + (+opt.dataset.price || 0)) }) : AYASA_t(sel ? "js.shop.total_plus_case" : "js.shop.total", { price: eur(c.price) });
    total.hidden = false;
    $("buyGo").innerHTML = future(c.ship) ? esc(AYASA_t("js.shop.preorder_ships", { date: shipLong(c.ship) })) : CART + esc(AYASA_t("js.shop.add_to_cart"));
  }
  function qaCondition(k) {
    QA.k = k;
    $("condNow").textContent = kindName(QA.conds[k].kind);
    document.querySelectorAll("#condMenu .cond-row").forEach(r => r.classList.toggle("on", +r.dataset.k === k));
    $("condMenu").hidden = true;
    $("condTrigger").setAttribute("aria-expanded", "false");
    qaTotal();
  }
  async function qaSubmit(e) {
    e.preventDefault();
    const err = $("buyError"), btn = $("buyGo");
    const sel = $("caseSelect"), size = $("shirtSize"), color = $("shirtColor");
    const needCase = !!sel && !sel.value, needShirt = !!size && !size.value;
    if (needCase || needShirt) {
      err.textContent = typeof choiceMessage === "function" ? choiceMessage(needCase, needShirt) : AYASA_t("js.shop.choose_case_and_shirt");
      err.hidden = false;
      if (needCase) { $("casePickerWrap")?.classList.add("open"); $("caseTrigger")?.setAttribute("aria-expanded", "true"); }
      return;
    }
    // exactly what the product page sends: the case first, the instrument last
    // (the last item of one add lands on top of the basket).
    // "Free t-shirt size" / "Free t-shirt color" are a contract with Flow: its
    // order intake matches these exact strings to print the packer's slip.
    // Declining attaches no properties at all — that absence is how Flow reads
    // "declined". Message the orders chat before changing either.
    const properties = {};
    if (size && size.value && size.value !== "No free t-shirt") {
      properties["Free t-shirt size"] = size.value;
      properties["Free t-shirt color"] = color.value;
    }
    const items = [{ id: +QA.conds[QA.k].variant, quantity: 1, properties }];
    if (sel) items.unshift({ id: +sel.value, quantity: 1 });
    btn.disabled = true;
    try {
      // the basket rules (ayasa-cart-rules-2.js): at most 3 of a model, and
      // Shopify's own stock message (which names the stock) never shows
      await window.AyasaCart.add(items, { instruments: [{ handle: QA.conds[QA.k].handle, quantity: 1 }], pan: true });
      try { if (typeof instrumentsFirst === "function") await instrumentsFirst(); } catch (e2) { console.error("basket order:", e2); }
      window.location.href = AYASA_localUrl("/cart");
    } catch (e3) {
      err.textContent = e3.message; err.hidden = false; btn.disabled = false;
    }
  }

  // ---- layer, filter sheet ----
  let lastFocus = null;
  // borrowed players always go home first: clearing the layer would destroy them
  function openLayer(html) { returnPlayers(); lastFocus = document.activeElement; const l = $("asLayer"); l.innerHTML = `<div class="overlay" id="asOv">${html}</div>`; l.querySelector(".close")?.focus(); }
  function closeLayer() { returnPlayers(); $("asLayer").innerHTML = ""; QA = null; lastFocus?.focus?.(); }
  function openFilters() { $("asFilters").classList.add("open"); if (!$("asScrim")) { const s = document.createElement("div"); s.className = "scrim"; s.id = "asScrim"; s.dataset.closeF = ""; root.appendChild(s); } }
  function closeFilters() { $("asFilters").classList.remove("open"); $("asScrim")?.remove(); }

  // ---- events ----
  function resetFilters() { LINES.forEach(l => S.lines.add(l.key)); Object.assign(S, { now: false, tone: "all", first: false, pmin: PMIN, pmax: PMAX, nmin: NMIN, nmax: NMAX }); S.keys.clear(); S.moods.clear(); renderAll(); }
  root.addEventListener("click", e => {
    const t = e.target;
    // Watch in the compare table: the site's lightbox opens; our layer steps aside
    if (t.closest("#asLayer .hear-btn[data-model]")) { closeLayer(); return; }
    const c = t.closest(".cmp");
    if (c) { e.preventDefault(); const i = +c.dataset.i, k = S.compare.indexOf(i);
      if (k >= 0) S.compare.splice(k, 1); else if (S.compare.length >= 3) { toast(AYASA_t("js.shop.compare_max")); return; } else S.compare.push(i);
      EL[i].querySelector(".cmp").setAttribute("aria-pressed", String(S.compare.includes(i))); renderTray(); return; }
    const a = t.closest(".add"); if (a) { e.preventDefault(); openQuickAdd(+a.dataset.i); return; }
    if (t.closest("#condTrigger")) { const m = $("condMenu"); m.hidden = !m.hidden; t.closest("#condTrigger").setAttribute("aria-expanded", String(!m.hidden)); return; }
    const cr = t.closest("#condMenu .cond-row"); if (cr) { qaCondition(+cr.dataset.k); return; }
    if (t.closest("#asCmpOpen")) { openCompare(); return; }
    if (t.closest("#asCmpClear")) { S.compare = []; renderItems(); renderTray(); return; }
    if (t.closest("[data-close]") || t.id === "asOv") { closeLayer(); return; }
    if (t.closest("[data-close-f]")) { closeFilters(); return; }
    if (t.closest("#asFbtn")) { openFilters(); return; }
    const tone = t.closest("[data-tone]"); if (tone) { S.tone = tone.dataset.tone; renderAll(); return; }
    const key = t.closest("[data-key]"); if (key) { const k = key.dataset.key; S.keys.has(k) ? S.keys.delete(k) : S.keys.add(k); renderAll(); return; }
    const pill = t.closest("[data-pill]");
    if (pill) { const { pill: p, v } = pill.dataset;
      if (p === "line") LINES.forEach(l => S.lines.add(l.key)); else if (p === "now") S.now = false; else if (p === "tone") S.tone = "all"; else if (p === "key") S.keys.delete(v); else if (p === "mood") S.moods.delete(v);
      else if (p === "notes") { S.nmin = NMIN; S.nmax = NMAX; } else if (p === "first") S.first = false; else if (p === "price") { S.pmin = PMIN; S.pmax = PMAX; }
      renderAll(); return; }
    if (t.id === "asClearAll" || t.id === "asClearAll2") { resetFilters(); return; }
    if (t.closest("#asList") || t.closest("#asGrid")) {
      S.view = t.closest("#asGrid") ? "grid" : "list";
      // the merged card and the old row: the other layout is a reload away
      if (MIXROWS) { try { localStorage.setItem(VIEW_KEY, `${S.view}@mix`); } catch (err) {} if ((S.view === "list") !== (LAYOUT === "list")) location.reload(); else renderItems(); return; }
      try { localStorage.setItem(VIEW_KEY, `${S.view}@${LAYOUT}`); } catch (err) {} renderItems();
    }
  });
  function readDual(key, scale, min, max) {
    let lo = +$("as" + key + "Min").value * scale, hi = +$("as" + key + "Max").value * scale;
    lo = Math.max(min, Math.min(lo || min, max)); hi = Math.min(max, Math.max(hi || max, min)); if (lo > hi) [lo, hi] = [hi, lo];
    return [lo, hi];
  }
  root.addEventListener("change", e => {
    const t = e.target;
    if (t.id.startsWith("as-l-")) t.checked ? S.lines.add(t.id.slice(5)) : S.lines.delete(t.id.slice(5));
    else if (t.id === "as-now") S.now = t.checked;
    else if (t.id === "as-first") S.first = t.checked;
    else if (t.id === "as-sec") S.seconds = t.checked;
    else if (t.id.startsWith("as-m-")) t.checked ? S.moods.add(t.id.slice(5)) : S.moods.delete(t.id.slice(5));
    else if (t.id === "asPMin" || t.id === "asPMax") [S.pmin, S.pmax] = readDual("P", 100, PMIN, PMAX);
    else if (t.id === "asNMin" || t.id === "asNMax") [S.nmin, S.nmax] = readDual("N", 1, NMIN, NMAX);
    else if (/^as[PN]R(Min|Max)$/.test(t.id)) { refreshCounts(t.id); return; }
    else if (t.id === "asSort") { S.sort = t.value; renderItems(); return; }
    else return;
    renderAll();
  });
  // sliders move smoothly while dragging; the list follows, the counts follow on release
  let rt = 0;
  root.addEventListener("input", e => {
    const t = e.target, m = /^as([PN])R(Min|Max)$/.exec(t.id); if (!m) return;
    const key = m[1], scale = key === "P" ? 100 : 1;
    let lo = +$("as" + key + "RMin").value * scale, hi = +$("as" + key + "RMax").value * scale;
    if (lo > hi) { if (m[2] === "Min") lo = hi; else hi = lo; t.value = (m[2] === "Min" ? lo : hi) / scale; }
    if (key === "P") { S.pmin = lo; S.pmax = hi; } else { S.nmin = lo; S.nmax = hi; }
    $("as" + key + "Min").value = lo / scale; $("as" + key + "Max").value = hi / scale; paintRanges();
    clearTimeout(rt); rt = setTimeout(() => { renderPills(); renderItems(); renderTray(); }, 120);
  });
  function refreshCounts(keepFocus) { const f = $("asFilters"); const st = f.scrollTop; renderFilters(); f.scrollTop = st; $(keepFocus)?.focus(); }

  // ---- the filter column follows the page instead of scrolling inside itself (Roy, 29-09) ----
  // When the filters fit on the screen they simply stay put under the header.
  // When they are taller than the screen, they scroll WITH the page until their
  // last group is in view and then stay there; scrolling back up brings the top
  // groups back the same way. No second scrollbar. Phones keep the bottom sheet.
  const side = $("asFilters");
  const wide = matchMedia("(min-width: 901px)");
  let sideTop = null, sideOffset = null, lastY = scrollY, sideRaf = 0;
  function followPage() {
    sideRaf = 0;
    if (!wide.matches) { side.style.top = ""; sideOffset = null; lastY = scrollY; return; }
    if (sideTop == null) { side.style.top = ""; sideTop = parseFloat(getComputedStyle(side).top) || 86; }
    const room = innerHeight - sideTop - 16;               // what fits under the header
    const h = side.offsetHeight;
    if (h <= room) { side.style.top = sideTop + "px"; sideOffset = sideTop; lastY = scrollY; return; }
    const lowest = innerHeight - h - 16;                   // top at which the last group just shows
    if (sideOffset == null) sideOffset = sideTop;
    sideOffset = Math.max(lowest, Math.min(sideTop, sideOffset - (scrollY - lastY)));
    lastY = scrollY;
    side.style.top = sideOffset + "px";
  }
  const queueFollow = () => { if (!sideRaf) sideRaf = requestAnimationFrame(followPage); };
  addEventListener("scroll", queueFollow, { passive: true });
  addEventListener("resize", () => { sideTop = null; queueFollow(); });
  wide.addEventListener?.("change", () => { sideTop = null; queueFollow(); });
  // the column changes height when a filter adds "Clear all filters" or counts change
  if (typeof ResizeObserver === "function") new ResizeObserver(queueFollow).observe(side);
  queueFollow();
  root.addEventListener("submit", e => { if (e.target.id === "asQaForm") qaSubmit(e); });
  document.addEventListener("keydown", e => { if (e.key === "Escape") { if ($("asOv")) closeLayer(); else closeFilters(); } });

  buildItems();
  renderAll();
})();
